import React from 'react';
import { Profile } from '@atlaskit/atlassian-navigation';

import { AVATARS_BASE_URL } from '@/constants';
import { useAuthController } from '@/controllers';

const NavProfile: React.FC = () => {
  const { username } = useAuthController();
  const url = `${AVATARS_BASE_URL}/${username}?size=small`;

  return (
    <Profile
      icon={
        <img
          style={{ borderRadius: '50%', objectFit: 'cover', width: 24, height: 24 }}
          src={url}
          alt=""
        />
      }
      tooltip={`Logged in as ${username}@atlassian.com`}
    />
  );
};

export default NavProfile;
